import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["relatedUrlsResponse", "renderers", "testId", "initializeOpened"];
import React from 'react';
import { messages } from '../../../../../../messages';
import Block from '../../block';
import RelatedUrlsList from './related-url-list';
export var RelatedUrlsResolvedView = function RelatedUrlsResolvedView(_ref) {
  var resolvedResults = _ref.relatedUrlsResponse.resolvedResults,
    renderers = _ref.renderers,
    testId = _ref.testId,
    initializeOpened = _ref.initializeOpened,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
    testId: testId
  }), resolvedResults && /*#__PURE__*/React.createElement(RelatedUrlsList, {
    testId: "".concat(testId, "-list"),
    renderers: renderers,
    initializeOpened: initializeOpened,
    title: messages.last_mentioned_in,
    resolvedResults: resolvedResults
  }));
};